// extracted by mini-css-extract-plugin
module.exports = {"header":"AddStockModal_header_2Mos5","wrapper":"AddStockModal_wrapper_3uyas"};